import { AppConstants } from "../constants/constants";

export function getValueFromQueryParams(
  url: string,
  searchedParam: string
): string {
  let queryParams = url.split(AppConstants.URL_QUERY_DELIM)[1];
  let searchParam = new URLSearchParams(queryParams);
  return searchParam.get(searchedParam);
}
